<template>
    <div v-if="hint !== false">
        <div class="text-affili-cerise">
            <span @click="openModal" class="cursor-pointer">
                <!-- {{ $t('page_hint') }} -->
                <FaIcon class="align-middle" icon="question-circle"/>
            </span>
        </div>

        <CModal
            :title="$t('hint')"
            :show.sync="showModal"
            size="lg"
            borderColor="info"
        >
            <component v-bind:is="hint"></component>

            <CButton @click="showModal = false" color="info" class="float-right">
                {{ $t('i_understand') }}
            </CButton>

            <template #footer-wrapper>
                <span></span>
            </template>
        </CModal>
    </div>
</template>

<script>
export default {
    name: 'PageHint',
    props: {
        hint: {
            default: ''
        }
    },
    data: function() {
        return {
            showModal: false,
        }
    },
    computed: {
    },
    methods: {
        openModal() {
            this.showModal = true
        }
    },
}
</script>

<style scoped lang="scss">
::v-deep {
    @keyframes showhide {
        0% {opacity: 1;}
        50% {opacity: 0;}
        100% {opacity: 1;}
    }
    .hint-me {
        position: relative;
        animation: showhide 1.5s infinite;
        animation-timing-function: linear;
    }
    .hint-me:hover {
        opacity: 1!important;
        animation: none;
    }
}
</style>